import { GALLERY } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import SafeImage from "./SafeImage";

export default function Gallery() {
    const ref = useReveal();
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="bg-neutral-bg py-24 sm:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal mb-12 max-w-3xl">
                    <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                        Gallery
                    </span>
                    <h2 className="mt-3 font-display text-4xl font-bold tracking-[-0.025em] sm:text-6xl">
                        Farm to export, in frames.
                    </h2>
                </div>

                <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-4 md:grid-rows-3">
                    <GalleryTile src={GALLERY[0]} className="md:col-span-2 md:row-span-2 aspect-square md:aspect-auto" />
                    <GalleryTile src={GALLERY[1]} className="aspect-square" />
                    <GalleryTile src={GALLERY[2]} className="aspect-square" />
                    <GalleryTile src={GALLERY[3]} className="aspect-square md:col-span-2" />
                    <GalleryTile src={GALLERY[4]} className="aspect-square" />
                    <GalleryTile src={GALLERY[5]} className="aspect-square" />
                    <GalleryTile src={GALLERY[6]} className="col-span-2 aspect-[2/1] md:col-span-4 md:aspect-[4/1]" />
                </div>
            </div>
        </section>
    );
}

function GalleryTile({ src, className = "" }) {
    return (
        <div
            data-testid="gallery-tile"
            className={`group relative overflow-hidden rounded-3xl bg-black/5 ${className}`}
        >
            <SafeImage src={src} alt="" className="transition-transform duration-700 ease-out group-hover:scale-[1.07]" />
        </div>
    );
}
